import React from 'react';
import { useIntl } from 'react-intl';
import type { DateRedoItem } from 'fym-shared/src/music24/dateRedo';
import { TypedMemo } from '../../../../../common/types';
import { getFullAPIFileURL } from '../../../../../common/getFullAPIFileURL';
import { studioThemeMessages } from '../../../studio/studioThemeMessages';
import { dateRedoMessages as messages } from './dateRedoMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the date redo; each part uses its own slice of it */
import styles from './DateRedo.module.scss';
/* eslint-enable css-modules/no-unused-class */

/** One file with the old date: its picture, its asset type and "1 Nov → 15 Oct". */
const DateRedoItemLineComponent: React.FC<{ item: DateRedoItem; newDateLabel: string | null }> = ({
  item,
  newDateLabel,
}) => {
  const intl = useIntl();
  const name = intl.formatMessage(studioThemeMessages[item.themeId].name);
  const newDate = newDateLabel ?? intl.formatMessage(messages.noDate);
  return (
    <div className={styles.item} data-testid={`date-redo-item-${item.uuid}`}>
      {item.thumbUrl === null ? (
        <span className={styles.thumb} aria-hidden="true" />
      ) : (
        <img className={styles.thumb} src={getFullAPIFileURL(item.thumbUrl)} alt="" />
      )}
      <b className={styles.name}>{name}</b>
      <span className={styles.dates}>
        {item.oldDate === null ? newDate : intl.formatMessage(messages.dateChange, { old: item.oldDate, new: newDate })}
      </span>
    </div>
  );
};

export const DateRedoItemLine = TypedMemo(DateRedoItemLineComponent);
